/**
 * Web Vitals Reporting
 * Measures and reports Core Web Vitals for performance monitoring.
 *
 * Core Web Vitals measured (web-vitals v5+):
 * - CLS (Cumulative Layout Shift): Visual stability
 * - INP (Interaction to Next Paint): Interactivity (replaced FID in v5)
 * - FCP (First Contentful Paint): Loading performance
 * - LCP (Largest Contentful Paint): Loading performance
 * - TTFB (Time to First Byte): Server response time
 */

export const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  } else if (process.env.NODE_ENV === 'production') {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      const handleVitals = (metric) => {
        console.log(`[Web Vitals] ${metric.name}:`, metric.value.toFixed(2), metric.rating);
      };

      onCLS(handleVitals);
      onINP(handleVitals);
      onFCP(handleVitals);
      onLCP(handleVitals);
      onTTFB(handleVitals);
    });
  }
};

/**
 * Helper function to send metrics to analytics service
 * @param {Object} metric - Web Vital metric object
 */
export const sendToAnalytics = (metric) => {
  // Example implementation for Google Analytics 4
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', metric.name, {
      event_category: 'Web Vitals',
      value: Math.round(metric.value),
      event_label: metric.id,
      non_interaction: true,
    });
  }

  // Example implementation for custom analytics endpoint
  // fetch('/api/analytics/vitals', {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify({
  //     name: metric.name,
  //     value: metric.value,
  //     rating: metric.rating,
  //     delta: metric.delta,
  //     id: metric.id,
  //     url: window.location.href,
  //     timestamp: Date.now(),
  //   }),
  // });
};

export default reportWebVitals;
